(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simi-ugc-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.simiInstagramModalBound) return;
    window.simiInstagramModalBound = true;

    let activeDialog = null;
    let returnFocus = null;
    let pointerState = null;
    let suppressedTrigger = null;

    const getTrigger = (target) =>
      target instanceof Element ? target.closest('[data-simi-instagram-open]') : null;

    const cleanInstagramUrl = (value) => {
      try {
        const url = new URL(value);
        const hostAllowed = ['instagram.com', 'www.instagram.com'].includes(url.hostname);
        const pathAllowed = /^\/(p|reel)\/[^/]+\/?$/.test(url.pathname);
        if (!hostAllowed || !pathAllowed) return null;
        return `https://www.instagram.com${url.pathname}`;
      } catch (error) {
        return null;
      }
    };

    const loadEmbedScript = () => {
      if (window.instgrm?.Embeds) return Promise.resolve(window.instgrm);
      if (window.simiInstagramEmbedPromise) return window.simiInstagramEmbedPromise;

      window.simiInstagramEmbedPromise = new Promise((resolve, reject) => {
        let script = document.querySelector('script[data-simi-instagram-embed]');

        const handleLoad = () => {
          if (window.instgrm?.Embeds) {
            resolve(window.instgrm);
          } else {
            script?.remove();
            reject(new Error('Instagram embed API unavailable'));
          }
        };

        const handleError = () => {
          script?.remove();
          reject(new Error('Instagram embed script failed to load'));
        };

        if (!script) {
          script = document.createElement('script');
          script.async = true;
          script.src = 'https://www.instagram.com/embed.js';
          script.dataset.simiInstagramEmbed = '';
        }

        script.addEventListener('load', handleLoad, { once: true });
        script.addEventListener('error', handleError, { once: true });
        if (!script.isConnected) document.body.append(script);
      }).catch((error) => {
        window.simiInstagramEmbedPromise = null;
        throw error;
      });

      return window.simiInstagramEmbedPromise;
    };

    const clearDialog = (dialog) => {
      dialog._simiEmbedObserver?.disconnect();
      dialog._simiEmbedObserver = null;
      dialog.querySelector('[data-simi-instagram-mount]')?.replaceChildren();
      document.documentElement.classList.remove('simi-modal-open');
      activeDialog = null;

      if (returnFocus?.isConnected) returnFocus.focus({ preventScroll: true });
      returnFocus = null;
    };

    document.addEventListener('pointerdown', (event) => {
      const trigger = getTrigger(event.target);
      if (!trigger) return;
      pointerState = {
        trigger,
        pointerId: event.pointerId,
        startX: event.clientX,
        startY: event.clientY,
        moved: false,
      };
    });

    document.addEventListener('pointermove', (event) => {
      if (!pointerState || pointerState.pointerId !== event.pointerId) return;
      const distance = Math.hypot(event.clientX - pointerState.startX, event.clientY - pointerState.startY);
      if (distance > 8) pointerState.moved = true;
    });

    document.addEventListener('pointerup', (event) => {
      if (!pointerState || pointerState.pointerId !== event.pointerId) return;
      if (pointerState.moved) {
        suppressedTrigger = pointerState.trigger;
        window.setTimeout(() => {
          suppressedTrigger = null;
        }, 0);
      }
      pointerState = null;
    });

    document.addEventListener('pointercancel', () => {
      pointerState = null;
    });

    document.addEventListener('click', async (event) => {
      const trigger = getTrigger(event.target);

      if (trigger) {
        if (trigger === suppressedTrigger) {
          event.preventDefault();
          return;
        }

        const postUrl = cleanInstagramUrl(trigger.dataset.postUrl);
        const section = trigger.closest('[data-simi-instagram-section]');
        const dialog = section?.querySelector('[data-simi-instagram-dialog]');
        const mount = dialog?.querySelector('[data-simi-instagram-mount]');
        const status = dialog?.querySelector('[data-simi-instagram-status]');
        const fallback = dialog?.querySelector('[data-simi-instagram-fallback]');
        if (!postUrl || !dialog || !mount || !status || !fallback) return;

        if (activeDialog?.open && activeDialog !== dialog) activeDialog.close();

        returnFocus = trigger;
        activeDialog = dialog;
        fallback.href = postUrl;
        status.hidden = false;
        status.textContent = status.dataset.loadingText || status.textContent;
        mount.replaceChildren();

        const embed = document.createElement('blockquote');
        embed.className = 'instagram-media';
        embed.dataset.instgrmPermalink = postUrl;
        embed.dataset.instgrmVersion = '14';
        const embedLink = document.createElement('a');
        embedLink.href = postUrl;
        embedLink.target = '_blank';
        embedLink.rel = 'noopener noreferrer';
        embed.append(embedLink);
        mount.append(embed);

        dialog._simiEmbedObserver?.disconnect();
        dialog._simiEmbedObserver = new MutationObserver(() => {
          if (mount.querySelector('iframe')) {
            status.hidden = true;
            dialog._simiEmbedObserver.disconnect();
          }
        });
        dialog._simiEmbedObserver.observe(mount, { childList: true, subtree: true });

        document.documentElement.classList.add('simi-modal-open');
        if (!dialog.open) dialog.showModal();

        try {
          const instagram = await loadEmbedScript();
          if (dialog.open && mount.contains(embed)) instagram.Embeds.process();
        } catch (error) {
          if (dialog.open) status.textContent = status.dataset.errorText;
        }
        return;
      }

      const closeButton =
        event.target instanceof Element ? event.target.closest('[data-simi-instagram-close]') : null;
      if (closeButton) closeButton.closest('dialog')?.close();

      const dialog = event.target instanceof HTMLDialogElement ? event.target : null;
      if (dialog?.matches('[data-simi-instagram-dialog]')) dialog.close();
    });

    document.addEventListener(
      'close',
      (event) => {
        if (event.target instanceof HTMLDialogElement && event.target.matches('[data-simi-instagram-dialog]')) {
          clearDialog(event.target);
        }
      },
      true
    );
  })();

  } catch(e) { console.error(e); }
})();
})();
